export default __webpack_public_path__ + "static/media/arrow_right_button.60cf2523.svg";